import { render } from "./vehicle_controls.vue?vue&type=template&id=2b681ed4&scoped=true"
import script from "./vehicle_controls.vue?vue&type=script&lang=js"
export * from "./vehicle_controls.vue?vue&type=script&lang=js"

import "./vehicle_controls.vue?vue&type=style&index=0&id=2b681ed4&scoped=true&lang=css"
import "./vehicle_controls.vue?vue&type=style&index=1&id=2b681ed4&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b681ed4"]])

export default __exports__